export default {
	props: {
		parent: {
			value: Object,
			default: undefined
		},
		authToken: {
			value: String
		},
		wrapperClass: {
			value: String
		},
		loaderClass: {
			value: String
		}
	},
	created() {
		if (this.parent === undefined) {
			this.parent = this.$parent;
		}
	},
	mounted() {
		if (!window.paypal || !window.paypal.checkout) {
			let checkoutSciprt = document.createElement('script');
			checkoutSciprt.setAttribute('src', 'https://www.paypalobjects.com/api/checkout.js');
			checkoutSciprt.setAttribute('data-version-4', '');
			checkoutSciprt.setAttribute('data-log-level', 'warn');
			document.head.appendChild(checkoutSciprt);
		}
		if (!window.braintree || !window.braintree.client) {
			let clientScript = document.createElement('script');
			clientScript.setAttribute('src', 'https://js.braintreegateway.com/web/3.45.0/js/client.min.js');
			document.head.appendChild(clientScript);
		}
		if (!window.braintree || !window.braintree.paypalCheckout) {
			let paypalCheckoutScript = document.createElement('script');
			paypalCheckoutScript.setAttribute('src', 'https://js.braintreegateway.com/web/3.45.0/js/paypal-checkout.min.js');
			document.head.appendChild(paypalCheckoutScript);
		}
		const vue = this;
		this.checkingInterval = setInterval(function() {
			if (window.paypal && window.braintree && window.paypal.checkout && window.braintree.client && window.braintree.paypalCheckout) {
				vue.externalReady = true;
			}
		}, 500);
	},
	watch: {
		externalReady: function(data) {
			if (data) {
				clearInterval(this.checkingInterval);
				this.createBT();
			}
		}
	},
	data() {
		return {
			isLoading: true,
			errorMessage: '',
			clientInstance: '',
			paypalCheckoutInstance: '',
			externalReady: false,
			checkingInterval: null
		};
	},
	methods: {
		createBT() {
			const client = require('braintree-web/client');
			client.create(
				{
					authorization: this.authToken
				},
				(clientErr, clientInstance) => {
					if (clientErr) {
						this.errorMessage = 'There was an error setting up the client instance. Message: ' + clientErr.message;
						this.$emit('btpaypelerror', this.errorMessage);
						return;
					} else {
						this.clientInstance = clientInstance;
						this.createPaypal();
					}
				}
			);
		},
		createPaypal() {
			const paypalCheckout = require('braintree-web/paypal-checkout');
			paypalCheckout.create(
				{
					client: this.clientInstance
				},
				(paypalCheckoutErr, paypalCheckoutInstance) => {
					const vue = this;
					// Stop if there was a problem creating PayPal Checkout.
					// This could happen if there was a network error or if it's incorrectly
					// configured.
					if (paypalCheckoutErr) {
						vue.errorMessage = 'There was an error setting up paypal! Message: ' + paypalCheckoutErr.message;
						vue.$emit('btpaypalerror', vue.errorMessage);
					}

					vue.paypalCheckoutInstance = paypalCheckoutInstance;
					// Set up PayPal with the checkout.js library
					paypal.Button.render(
						{
							env: 'production', // or 'sandbox'

							style: {
								shape: 'rect',
								label: 'checkout',
								size: 'medium',
								tagline: 'false'
							},

							payment: function() {
								return vue.paypalCheckoutInstance.createPayment({
									flow: 'vault'
								});
							},

							onAuthorize: function(data, actions) {
								vue.parent.isSaving = true;
								return vue.paypalCheckoutInstance.tokenizePayment(data, function(err, payload) {
									vue.$emit('btpaypelpayload', payload);
								});
							},

							onCancel: function(data) {
								//unused
							},

							onError: function(err) {
								vue.parent.isSaving = false;
								vue.$emit('btpaypalerror', err);
							}
						},
						'#paypal-button'
					).then(function() {
						// The PayPal button will be rendered in an html element with the id
						// `paypal-button`. This function will be called when the PayPal button
						// is set up and ready to be used.
						vue.isLoading = false;
					});
				}
			);
		}
	}
};



// WEBPACK FOOTER //
// ./app/components/paypal/script.js